// All pure general functions

/**
 * Create a SVG with attributes
 */
function makeSVG(tag, attrs) {
  var el = document.createElementNS("http://www.w3.org/2000/svg", tag);
  for (var k in attrs) el.setAttribute(k, attrs[k]);
  return el;
}

/**
 * Create a SVG text node
 */
function makeTextNode(text, attrs) {
  var textEl = document.createElementNS("http://www.w3.org/2000/svg", "text");
  var textWrapper = document.createElementNS("http://www.w3.org/2000/svg", "g");
  textEl.appendChild(document.createTextNode(text));
  for (var k in attrs) textEl.setAttribute(k, attrs[k]);
  textWrapper.appendChild(textEl);
  return textWrapper;
}

/**
 * Normalizes a string to be more suitable for searching. This includes:
 * - Removing accents (e.g. "é" -> "e")
 * - Converting to lowercase
 * 
 * When matching search queries against text, the query will be normalized using this
 * function, and then each word (token) of the result will be looked for in the normalized
 * text content to be searched.
 * 
 * Example: "  José   García  " -> "  jose   garcia  "
 * 
 * @param {string} str - The string to normalize
 * @returns {string} The normalized string
 */
function normalizeSearch(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

/** Given a search query for the students searcher, returns a list of normalized tokens.
 * 
 * Example: "  José   García  " -> ["jose", "garcia"]
 * 
 * Normalization includes:
 * - Removing accents (e.g. "é" -> "e")
 * - Converting to lowercase
 * - Splitting on whitespace
 * - Removing empty tokens
 * 
 * @param {string} query - The search query to tokenize
 * @returns {string[]} An array of normalized tokens
 */
function searchTokenize(query) {
  return normalizeSearch(query).split(/\s+/).filter(Boolean);
}

/**
 * Given a container element and an array of tokens, returns all list items
 * within the container that match all tokens.
 * 
 * @param {HTMLElement} container - The container element to search within
 * @param {string[]} tokens - An array of normalized tokens to match
 * @returns {NodeListOf<HTMLElement>} A list of matching elements
 */
function searchMatches(container, tokens) {
  const selector = "[data-search]" + tokens.map(t => `[data-search*="${CSS.escape(t)}"]`).join("");
  return container.querySelectorAll(selector);
}

function validateFMCRE(input) {
  const val = input.value;
  const maxShuttles = [0, 7, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 16, 16];

  if (!val) {
    input.setCustomValidity("");
    return;
  }

  if (!/^[1-9]\d*(,([1-9]\d*)?)?$/.test(val)) {
    input.setCustomValidity("The value must be in the format 'level,shuttle'");
    input.reportValidity();
    return;
  }

  const parts = val.split(",");
  const level = Number.parseInt(parts[0], 10);
  const shuttle = Number.parseInt(parts[1], 10);
  const maxShuttle = maxShuttles[level];

  if (level < 1 || level > 21) {
    input.setCustomValidity("Invalid Level - Must be 1 to 21");
  } else if (Number.isNaN(shuttle)) {
    input.setCustomValidity("Missing shuttle");
  } else if (shuttle < 1 || shuttle > maxShuttle) {
    input.setCustomValidity(`Invalid Shuttle for Level ${level} - Must be 1 to ${maxShuttle}`);
  } else {
    input.setCustomValidity("");
  }

  input.reportValidity();
}

window.utils = {
  grid: {
    isXS: (width) => width < 576, //576px
    isSM: (width) => width >= 576,
    isMD: (width) => width >= 768,
    isLG: (width) => width >= 992,
    isXL: (width) => width >= 1200,
    isXXL: (width) => width >= 1400,
  },

  makeSVG,
  makeTextNode,
  validateFMCRE
};

window.normalizeSearch = normalizeSearch;
window.searchMatches = searchMatches;
window.searchTokenize = searchTokenize;
window.validateFMCRE = validateFMCRE;